import enLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
      txtWebSite: '和家平台',
      txtWebSiteEn: 'HOGOLiving',
      copyRight:
            "<p>集团公司 版权所有 Copyright 1996-2020 hogoliving.com</p>",
      enLocale,
}

export default zh
